export const removeRetailerTokenFromUrl = (url: string = "") => {
  return url.replace(/\/retailer\/r_[0-9, a-z]+/g, "");
};
